<section class="section-white" *ngIf="trustedWaySectionData">
  <div [ngClass]="hasInside ? 'section-container-inside' : 'section-container'">
    <h2 class="section-heading mar-b-32">
      {{ trustedWaySectionData?.header }}
    </h2>
    <div class="section-customer-logos">
      <figure
        class="customer-logos"
        *ngFor="let icon of trustedWaySectionData?.icons"
      >
        <img
          loading="lazy"
          [src]="icon?.fields?.file?.url"
          alt="icon?.fields?.title"
          class="no-filter"
        />
      </figure>
    </div>
  </div>
</section>
